import type { DiffFilterState } from "../lib/diff-filter";
import type { InboundFilterState } from "../lib/inbound-filter";
import type { RevenueFilterState } from "../lib/revenue-filter";

export const diffKeys = {
  all: ["inventory-diff"] as const,
  lists: ["inventory-diff", "list"] as const,
  list: (filter: DiffFilterState) => ["inventory-diff", "list", filter] as const,
  history: (sku: string) => ["inventory-diff", "history", sku] as const,
};

export const inboundKeys = {
  all: ["inbound"] as const,
  lists: ["inbound", "list"] as const,
  list: (filter: InboundFilterState) => ["inbound", "list", filter] as const,
};

export const revenueKeys = {
  all: ["revenue"] as const,
  lists: ["revenue", "list"] as const,
  list: (filter: RevenueFilterState) => ["revenue", "list", filter] as const,
};
